export const LLM_PROMPTS_DIALOG_ID = "llm-prompts-editor-dialog";
